import { Link } from "react-router-dom";

const stats = [
  { value: "1200+", label: "收录爱情电影" },
  { value: "3600+", label: "专业影评" },
  { value: "58", label: "影评专题" },
  { value: "30万", label: "影迷同行" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-10 py-12 md:py-20 bg-secondary-50">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="text-xs font-label tracking-[0.2em] text-secondary-600">
            ABOUT US
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2 leading-snug">
            因为热爱，所以我们把每一部爱情电影都读得很慢
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            爱的色放电影致力于打造一个专注爱情题材的影视资料与影评平台。我们不满足于简单地罗列片单，而是为每一部电影整理详尽的剧情解析、幕后花絮与多维影评，让你在观影前后，都能找到值得停留的细节。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            无论你是想重温经典，还是寻找下一部要看的爱情片，我们都希望这里能成为你观影路上的一盏灯。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/special"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-secondary-300 text-secondary-800 text-sm font-medium hover:bg-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览影评专题
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50 border border-secondary-200 p-5 md:p-6"
            >
              <p className="font-heading font-bold text-2xl md:text-4xl text-primary-600">
                {s.value}
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}